<template>
  <div class="splide">
    <div
      v-if="hasSliderWrapper"
      class="splide__slider"
    >
      <div class="splide__track">
        <div class="splide__list">
          <slot />
        </div>
      </div>
    </div>

    <div
      v-else
      class="splide__track"
    >
      <div class="splide__list">
        <slot />
      </div>
    </div>

    <slot name="controls" />
  </div>
</template>

<script>
// eslint-disable-next-line import/no-named-default, import/no-extraneous-dependencies
import { default as Splide } from '@splidejs/splide';
import { EVENTS } from '@splidejs/vue-splide/src/js/constants/events';

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Splide',

  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
    hasSliderWrapper: Boolean,
    extensions: {
      type: Object,
      default: () => ({}),
    },
    transition: {
      type: Function,
      default: null,
    },
    slides: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      splide: null,
    };
  },

  computed: {
    index() {
      return this.splide.index;
    },

    length() {
      return this.splide.length;
    },
  },

  watch: {
    slides() {
      this.remount();
    },
  },

  mounted() {
    this.splide = new Splide(this.$el, this.options);
    this.bind();
    this.splide.mount(this.extensions, this.transition);
  },

  beforeDestroy() {
    this.splide.destroy();
  },

  methods: {
    go(control, wait = true) {
      this.splide.go(control, wait);
    },

    sync(splide) {
      this.splide.sync(splide);
      this.remount();
    },

    bind() {
      EVENTS.forEach((event) => {
        this.splide.on(event, (...args) => {
          this.$emit(`splide:${event}`, this.splide, ...args);
        });
      });
    },

    remount() {
      this.$nextTick(() => {
        this.splide.destroy();
        this.splide.mount();
        this.bind();
      });
    },
  },
};
</script>
